import React, { useEffect, useState } from "react";
// import ptBr from "../../../config/texts/pt-br";
import { CustomText } from "../../../components/index";
import Styles from "../styles";
import { FormFull } from "form-full";
import { hooks, masks } from "../../../utils";
import { fonts, SVG } from "../../../config";
import { Grid, Button } from "@material-ui/core";
import { customModal } from "../../../components/modals/utils";
import { Edit, Visibility, VisibilityOff, Person } from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { api } from "../../../services";
import ModalImage from "./ModalImage";
import { ModalViewQRCode } from "./ModalViewQRCode";
import { ThemeProvider, createTheme } from "@material-ui/core";
import { ButtonMenu } from "../../../components/index";

function ModalView({ onSubmit, item }) {
  // const texts = ptBr.login;
  // const [ QRCodeUrl, setQRCodeUrl ] = React.useState('');
  const { call } = hooks.useRequest();
  const [viewPasswords, setViewPasswords] = React.useState(false);
  const [passwordsGenerated, setPasswordsGenerated] = React.useState(
    <Styles.Value> Senhas não geradas </Styles.Value>
  );
  const [image, setImage] = useState(null);

  useEffect(() => {
    const imageId = item?.primaryGuest?.imageId;
    if (!imageId) {
      setImage(null);
      return;
    }
    call(null, api.getImageDownload(imageId), (response) => {
      if (response.ok) {
        setImage(response.data);
      } else {
        setImage(null);
      }
    });
  }, [item?.primaryGuest?.imageId]);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#FFFFFF",
      },
    },
  });

  function getButtons(itemGuest, fullItem) {
    if (itemGuest.imageId == null || itemGuest.imageId == undefined) {
      return [
        {
          label: "Link ",
          onClick: () =>
            customModal.setInfos(
              "Link da Imagem",
              [itemGuest.facialUrl],
              {
                onClick: () => {
                  customModal.close();
                  openModalView(fullItem);
                },
                label: "Voltar",
              },
              null,
              null,
              false,
              true,
              <Visibility />
            ),
        },
      ];
    } else {
      return [
        {
          label: "Link ",
          onClick: () => {
            customModal.setInfos(
              "Link da Imagem",
              [itemGuest.facialUrl],
              {
                onClick: () => {
                  customModal.close();
                  openModalView(fullItem);
                },
                label: "Voltar",
              },
              null,
              null,
              false,
              true,
              <Visibility />
            );
          },
        },
        {
          label: "Imagem",
          onClick: () => {
            openModalViewImg(fullItem, itemGuest);
          },
        },
      ];
    }
  }

  const drawMembers = (number: number) => {
    const membersForm: any = [];

    for (let index = 0; index < number; index++) {
      const [viewPasswordsSecondary, setViewPasswordsSecondary] =
        React.useState(false);
      membersForm.push(
        <>
          <CustomText
            fontFamily={fonts.bold}
            fontSize={14 / 8}
            textColor="#B2B2B2"
            style={{ paddingTop: "25px" }}
          >
            ACOMPANHANTE #{index + 1}
          </CustomText>
          <Grid alignItems="flex-end" container spacing={5}>
            <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>Nome Completo</Styles.Label>
              <Styles.Value>{item?.secondaryGuests[index]?.name}</Styles.Value>
            </Grid>{" "}
            {/* <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>Documento</Styles.Label>
              <Styles.Value>
                {item?.secondaryGuests[index]?.document
                  ? masks.CPF(item?.secondaryGuests[index]?.document)
                  : item?.secondaryGuests[index]?.passport}
              </Styles.Value>
            </Grid> */}
            <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>DATA NASCIMENTO</Styles.Label>
              <Styles.Value>
                {item?.secondaryGuests[index]?.birthDate &&
                  masks.formatDate(item?.secondaryGuests[index].birthDate)}
              </Styles.Value>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>E-Mail</Styles.Label>
              <Styles.Value>{item?.secondaryGuests[index]?.email}</Styles.Value>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>Telefone</Styles.Label>
              <Styles.Value>
                {masks.inputMaskTELWithDDD(item?.secondaryGuests[index]?.phone)}
              </Styles.Value>
            </Grid>
            {/* <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>Placa do veículo</Styles.Label>
              <Styles.Value>
                {item?.secondaryGuests[index]?.vehiclePlate}
              </Styles.Value>
            </Grid> */}
            <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>ASSINATURA FACIAL</Styles.Label>
              <Styles.Value>
                {item?.secondaryGuests[index]?.imageId
                  ? "doc-facial.png"
                  : "Sem Imagem"}

                {item.secondaryGuests[index]?.imageId ? (
                  <ButtonMenu
                    endIcon={<Visibility />}
                    buttons={getButtons(item?.secondaryGuests[index], item)}
                  >
                    Vizualizar
                  </ButtonMenu>
                ) : (
                  <ButtonMenu
                    endIcon={<Visibility />}
                    buttons={getButtons(item?.secondaryGuests[index], item)}
                  >
                    Tirar Foto
                  </ButtonMenu>
                )}
              </Styles.Value>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>Senhas</Styles.Label>
              {item?.secondaryGuests[index]?.passwords.length == 0 ||
              item?.secondaryGuests[index]?.passwords == null ? (
                passwordsGenerated
              ) : (
                <Styles.Value>
                  {viewPasswordsSecondary
                    ? item?.secondaryGuests[index]?.passwords.join(", ")
                    : masks.passwords(item?.secondaryGuests[index]?.passwords)}
                  <Button
                    onClick={() =>
                      setViewPasswordsSecondary(!viewPasswordsSecondary)
                    }
                    disableRipple
                    size="small"
                    style={{ padding: 0, marginTop: 0, minWidth: "30%" }}
                  >
                    <ThemeProvider theme={theme}>
                      <VisibilityIcon color="primary" />
                    </ThemeProvider>
                  </Button>
                </Styles.Value>
              )}
            </Grid>
            {/* <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>QR Code</Styles.Label>
                <Styles.Value>
                  <Styles.ValueSpan
                    onClick={() => {
                        openModalViewImg(item, item?.secondaryGuests[index]);
                    }}
                  >
                    Gerar QR Code <Visibility />
                  </Styles.ValueSpan>
                </Styles.Value>
            </Grid> */}
          </Grid>
        </>
      );
    }
    return membersForm;
  };

  const openModalViewImg = (fullItem, imageData) => {
    customModal.setInfos(
      "doc-facial.png",
      [],
      {
        onClick: () => {
          customModal.close();
          openModalView(fullItem);
        },
        label: "Voltar",
      },
      null,
      <ModalImage item={imageData} />,
      false,
      true,
      null
    );
  };

  const openModalView = (item) => {
    customModal.setInfos(
      "Cadastrar Reserva",
      [],
      {
        onClick: () => {
          customModal.close();
        },
        label: "Voltar",
      },
      null,
      <ModalView item={item} onSubmit={(value) => console.log(value)} />,
      false,
      true,
      <SVG.File />
    );
  };

  // {openEdit ? (
  //   <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
  //     <Button
  //       size="small"
  //       variant="outlined"
  //       onClick={() => openEdit(item)}
  //       startIcon={<Edit />}
  //     >
  //       Editar Reserva
  //     </Button>
  //   </div>
  // ) : null}

  useEffect(() => {
    const passwordsToShow = [
      ...item?.passwords,
      ...item?.primaryGuest?.passwords,
    ];
    if (!passwordsToShow || passwordsToShow.length === 0)
      return setPasswordsGenerated(
        <Styles.Value> Senhas não geradas </Styles.Value>
      );
    setPasswordsGenerated(
      <Styles.Value>
        <p>
          {viewPasswords
            ? passwordsToShow.join(", ")
            : masks.passwords(passwordsToShow)}
        </p>
        <Button
          onClick={() => setViewPasswords(!viewPasswords)}
          disableRipple
          size="small"
          style={{ padding: 0, marginTop: 0, minWidth: "30%" }}
        >
          <ThemeProvider theme={theme}>
            {viewPasswords ? (
              <VisibilityIcon color="primary" />
            ) : (
              <VisibilityOff color="primary" />
            )}
          </ThemeProvider>
        </Button>
      </Styles.Value>
    );
  }, [viewPasswords, item]);

  function QrCodeModals() {
    customModal.setInfos(
      "Alerta QR Code",
      [
        "Gerar QR Code para acesso do Hóspede? Caso esse hospede já possua um QR Code, seu código antigo será invalidado.",
      ],
      {
        onClick: () => {
          customModal.close();
          call(null, api.getQRCode(item.id), (response) => {
            if (response.ok) {
              customModal.setInfos(
                "Vizualizar QR Code",
                [],
                {
                  onClick: () => {
                    customModal.close();
                  },
                  label: "Voltar",
                },
                null,
                <ModalViewQRCode qrCodeUrl={response?.data} />,
                false,
                true,
                <Visibility />
              );
            } else {
              console.log("Erro ao gerar QR Code");
              console.log(response);
              console.log(response.data);
              customModal.close();
            }
          });
        },
        label: "Gerar QR Code",
      },
      null,
      null,
      false,
      false,
      null
    );
  }

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          minWidth: "clamp(300px, 54vw, 1055px)",
          paddingInline: "25px",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",

            padding: "24px",
            overflow: "auto",
            maxHeight: "430px",
            borderRadius: "5px",
          }}
        >
          <FormFull
            onSubmit={(data) => {
              onSubmit(data);
            }}
          >
            <CustomText
              fontFamily={fonts.bold}
              fontSize={14 / 8}
              textColor="#0C396D"
              style={{ marginBottom: "16px" }}
            >
              LOCATÁRIO PRIMÁRIO
            </CustomText>
            <Grid container spacing={2}>
              {/* Imagem à esquerda */}
              <Grid item xs={12} md={3}>
                <Styles.ImageLabel>Assinatura Facial</Styles.ImageLabel>
                <Styles.ImageBox>
                  {item?.primaryGuest?.imageId ? (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "relative",
                      }}
                    >
                      {image ? (
                        <div
                          style={{
                            borderRadius: "5px",
                            maxHeight: "80vh",
                            maxWidth: "80vw",
                            height: "100%",
                            width: "100%",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            backgroundSize: "cover",
                            backgroundImage: `url(${image})`,
                          }}
                        />
                      ) : (
                        <Person style={{ fontSize: 80, color: "#B0B0B0" }} />
                      )}
                      <div
                        style={{ position: "absolute", bottom: 8, right: 8 }}
                      >
                        <ButtonMenu
                          endIcon={<Visibility />}
                          buttons={getButtons(item?.primaryGuest, item)}
                        >
                          Visualizar
                        </ButtonMenu>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                      }}
                    >
                      <ButtonMenu
                        endIcon={<Visibility />}
                        buttons={getButtons(item?.primaryGuest, item)}
                      >
                        Tirar Foto
                      </ButtonMenu>
                    </div>
                  )}
                </Styles.ImageBox>
              </Grid>

              {/* Cards à direita — 3 colunas em desktop (md=4 cada) */}
              <Grid item xs={12} md={9} style={{marginTop: '3.5vh'}}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={4}>
                    <Styles.Card>
                      <Styles.CardTitle>Nome Completo</Styles.CardTitle>
                      <Styles.CardContent>
                        {item?.primaryGuest?.name || "-"}
                      </Styles.CardContent>
                    </Styles.Card>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Styles.Card>
                      <Styles.CardTitle>Documento</Styles.CardTitle>
                      <Styles.CardContent>
                        {item?.primaryGuest?.document
                          ? masks.CPF(item?.primaryGuest?.document)
                          : item?.primaryGuest?.passport || "-"}
                      </Styles.CardContent>
                    </Styles.Card>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Styles.Card>
                      <Styles.CardTitle>Data de Nascimento</Styles.CardTitle>
                      <Styles.CardContent>
                        {item?.primaryGuest?.birthDate
                          ? masks.formatDate(item?.primaryGuest?.birthDate)
                          : "-"}
                      </Styles.CardContent>
                    </Styles.Card>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Styles.Card>
                      <Styles.CardTitle>E-Mail</Styles.CardTitle>
                      <Styles.CardContent>
                        <div
                          style={{
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                            width: "100%",
                            display: "block",
                          }}
                        >
                          {item?.primaryGuest?.email || "-"}
                        </div>
                      </Styles.CardContent>
                    </Styles.Card>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Styles.Card>
                      <Styles.CardTitle>Telefone</Styles.CardTitle>
                      <Styles.CardContent>
                        {masks.inputMaskTELWithDDD(item?.primaryGuest?.phone) ||
                          "-"}
                      </Styles.CardContent>
                    </Styles.Card>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Styles.Card>
                      <Styles.CardTitle>Placa do Veículo</Styles.CardTitle>
                      <Styles.CardContent>
                        {item?.primaryGuest?.vehiclePlate || "-"}
                      </Styles.CardContent>
                    </Styles.Card>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Styles.Card>
                      <Styles.CardTitle>Assinatura Facial</Styles.CardTitle>
                      <Styles.CardContent>
                        {item?.primaryGuest?.imageId
                          ? "facial.jpeg"
                          : "Sem Imagem"}
                      </Styles.CardContent>
                    </Styles.Card>
                  </Grid>

                  <Grid item xs={12} md={8}>
                    <Styles.Card>
                      <Styles.CardTitle>Senhas</Styles.CardTitle>
                      <Styles.CardContent>
                        {viewPasswords
                          ? item?.passwords && item?.primaryGuest?.passwords
                            ? [
                                ...item?.passwords,
                                ...item?.primaryGuest?.passwords,
                              ].join(", ")
                            : "-"
                          : masks.passwords(
                              item?.passwords && item?.primaryGuest?.passwords
                                ? [
                                    ...item?.passwords,
                                    ...item?.primaryGuest?.passwords,
                                  ]
                                : []
                            )}

                        <ThemeProvider theme={theme}>
                          <Button
                            onClick={() => setViewPasswords(!viewPasswords)}
                            size="small"
                            style={{
                              padding: 0,
                              marginTop: 0,
                              minWidth: "30%",
                            }}
                          >
                            <VisibilityIcon />
                          </Button>
                        </ThemeProvider>
                      </Styles.CardContent>
                    </Styles.Card>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {drawMembers(item.numGuests)}
          </FormFull>
        </div>
      </div>
    </>
  );
}

export default ModalView;
